import { ExchangeMoneyEnum } from './ExchangeModel';

export class MoneyModel {
    public selected: boolean = false;
    public interactive: boolean = true;

    constructor(public state: ExchangeMoneyEnum = ExchangeMoneyEnum.empty) {
    }
}
